import { useRouter } from 'next/router';
import $ from 'jquery';
import ApiUrl from '../url.json';
import { useState, useEffect, useRef } from 'react';
import React from 'react';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import { useSession, signIn, signOut } from "next-auth/react";
import SignOut from "./components/signOut";
import styles from "../styles/index.module.css";
import axios from "axios";
import ResetPassModal from "./components/resetPassModal"
import cancelRequests from '../utils/cancelRequests';

export default function Login({ }) {
    const { data: session } = useSession();
    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get("id");
    const jobid = urlParams.get("jobid");
    const jobtype = urlParams.get("jobtype");
    const router = useRouter();
    const { redirectTo } = router.query; // Extract redirectTo from query parameters
    const [resetPassOpen, setResetPassOpen] = useState(true);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isNewUser, setIsNewUser] = useState(false);

    const [showModal, setShowModal] = useState(false);
    const isMountedRef = useRef(true);
    const { createCancelableAxiosOptions } = cancelRequests();
    const hasFetchedUser = useRef(false);
    useEffect(() => {
        isMountedRef.current = true;
        const handleLogin = async () => {
            if (session?.user && (!localStorage.getItem("jwt") || localStorage.getItem("jwt") === "undefined") && !hasFetchedUser.current) {
                try {
                    hasFetchedUser.current = true;
                    if (session?.user?.email) { // AD login
                        const userid = session.user.email;
                        const userADtoken = session.accessToken;
                        const body = JSON.stringify({
                            "emailid": userid,
                            "adtoken": userADtoken,
                        });

                        const config = createCancelableAxiosOptions({
                            method: 'post',
                            url: ApiUrl.newUrl + '/api/getUser',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            data: body,
                        });

                        const response = await axios(config);
                        // axios(config)
                        //     .then(function (response) {
                        // console.log(JSON.stringify(response.data));
                        if (response.data.success && isMountedRef.current) {
                            document.cookie = "jwt=" + response.data.token;
                            localStorage.setItem("jwt", response.data.token);
                            localStorage.setItem('userId', userid);
                            localStorage.setItem("globalid", userid);
                            localStorage.setItem('roles', response.data.roles);
                            localStorage.setItem("_id", response.data.userid);
                            localStorage.setItem("company", response.data.companyName);
                            localStorage.setItem("name", response.data.username);
                            localStorage.setItem('menubardata', response.data.menubar);
                            // console.log('menubardata: ', localStorage.getItem('menubardata'));
                            let sideMenuArr = [];
                            try {
                                const menuBar = response.data.menubar;
                                sideMenuArr = menuBar?.dashboard?.[1]?.sideMenu || [];
                                if (sideMenuArr && sideMenuArr.length > 0) {
                                    sideMenuArr.forEach((item) => {
                                        if (item["URL"]) {
                                            router.prefetch(item["URL"]);

                                        }
                                    });
                                }
                            } catch (err) {
                                console.error('Failed to parse menubardata:', err);
                            }
                            if (['Admin', 'Internal User', 'Internal Admin', 'External User'].includes(session?.user?.roles[0])) {
                                // Redirect after successful login
                                if (jobid && id) {
                                    router.push(`/jobs/approvals?jobtype=${jobtype}&jobid=${jobid}&id=${id}`);
                                } else if (redirectTo) {
                                    router.push(`/${redirectTo}`);
                                } else {
                                    if (localStorage.getItem('roles') === "Internal User") {
                                        router.push("/jobs/positions");
                                    } else {
                                        router.push("/admin-center/positions");
                                    }
                                }
                            }
                        } else {
                            // alert("Login failed");
                            signOut();
                        }
                        // })
                        // .catch(function (error) {
                        //     console.log(error);
                        //     // alert("Login failed");
                        //     signOut();
                        // });
                    }
                    else if (session?.user?.userid) {
                        // Redirect after successful login
                        if (session.user.isNewUser != true) {
                            if (!isMountedRef.current) return;
                            setIsNewUser(false);
                            document.cookie = "jwt=" + session.user.token;
                            localStorage.setItem('jwt', session.user.token);
                            localStorage.setItem('userId', session.user.emailid);
                            session.user.email = session.user.emailid;
                            localStorage.setItem("globalid", session.user.emailid);
                            localStorage.setItem('roles', session.user.roles[0]);
                            localStorage.setItem("_id", session.user.userid);
                            localStorage.setItem("company", session.user.companyName);
                            localStorage.setItem("name", session.user.name);
                            const options = createCancelableAxiosOptions({
                                headers: { jwt: session.user.token },
                            });
                            const result = await axios.post(ApiUrl.newUrl + '/api/GetMenuBarData', "", options);
                            // .then((result) => {
                            const data = result.data;
                            if (data && isMountedRef.current) {
                                localStorage.setItem('menubardata', JSON.stringify(data.data));
                                let sideMenuArr = [];
                                try {
                                    const menuBar = data.data;
                                    sideMenuArr = menuBar?.dashboard?.[1]?.sideMenu || [];
                                    if (sideMenuArr && sideMenuArr.length > 0) {
                                        sideMenuArr.forEach((item) => {
                                            if (item["URL"]) {
                                                router.prefetch(item["URL"]);

                                            }
                                        });
                                    }
                                    if (jobid && id) {
                                        router.push(`/jobs/approvals?jobtype=${jobtype}&jobid=${jobid}&id=${id}`);
                                    } else if (redirectTo) {
                                        router.push(`/${redirectTo}`);
                                    } else {
                                        if (localStorage.getItem('roles') === "Internal User") {
                                            router.push("/jobs/positions");
                                        } else {
                                            router.push("/admin-center/positions");
                                        }
                                    }
                                } catch (err) {
                                    console.error('Failed to parse menubardata:', err);
                                }
                            }
                            // })
                            // .catch((error) => {
                            //     console.error('Error fetching menu bar data:', error);
                            // });

                        }
                        else {
                            if (isMountedRef.current) setIsNewUser(true);
                        }
                    }
                    else {
                        // alert("Login failed");
                        signOut();
                        document.cookie = 'jwt=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
                        localStorage.clear();
                    }
                } catch (error) {
                    if (axios.isCancel(error)) {
                        console.log('Login request cancelled');
                    } else {
                        console.error('Login error:', error);
                        signOut();
                    }
                }
            } else if (session && localStorage.getItem("jwt")) {
                if (['Admin', 'Internal User', 'Internal Admin', 'External User'].includes(session?.user?.roles[0])) {
                    // Redirect if already logged in
                    if (jobid && id) {
                        router.push(`/jobs/approvals?jobtype=${jobtype}&jobid=${jobid}&id=${id}`);
                    } else if (redirectTo) {
                        router.push(`/${redirectTo}`);
                    } else {
                        if (localStorage.getItem('roles') === "Internal User") {
                            router.push("/jobs/positions");
                        } else {
                            router.push("/admin-center/positions");
                        }
                    }
                }
                // }else{
                //     router.push('/');
            }
        }
        handleLogin();

        return () => {
            isMountedRef.current = false;
        };
    }, [session, redirectTo, router]);

    if (session) {


        return (
            <>
                <div>

                    {isNewUser && <div className={styles.loginPage}> <ResetPassModal isOpen={resetPassOpen} onRequestClose={setResetPassOpen} /></div>}


                </div>
            </>
        );
    } else {
        return (<SignOut />);
    }
}
